import React from 'react';


class ProjectHistoryEntry extends React.Component {

    render() {

        var entryContainerStyle = {
            backgroundColor: "#1d1d1d",
            padding: 10,
            marginBottom: 10,
            borderRadius: 5,
        }

        var titleStyle = {
            margin: 0,
            marginBottom: 0,
        }

        var titleTextStyle = {
            textDecoration: 'underline',
            marginTop: 0,
            marginBottom: 5,
        }

        var bodyStyle = {
            marginLeft: 10,
            marginBottom: 5,
        }

        var subsectionTitle = {
            fontSize: "80%",
            fontStyle: "italic",
            marginTop: 5,
            marginBottom: 0,
            padding: 0,
        }

        var subsectionBody = {
            marginLeft: 10,
            fontSize: "75%",
            marginTop: 5,
            marginBottom: 0,
            padding: 0,
        }

        var toDate = " - " + this.props.project.todate;
        if(this.props.project.todate === "") {
            toDate = "";
        }
        return (
            <div style={entryContainerStyle}>
                <p style={titleStyle}>{this.props.project.fromdate}{toDate} : {this.props.project.duration}</p>
                <p style={titleTextStyle}>{this.props.project.title}</p>
                {this.props.project.graphs.map((graph) =>
                    <p style={bodyStyle}>{graph}</p>
                )}
                <p style={subsectionTitle}>Industries:</p>
                <p style={subsectionBody}>
                    {this.props.project.industries.join(', ')}
                </p>
                <p style={subsectionTitle}>Technologies:</p>
                <p style={subsectionBody}>
                    {this.props.project.technologies.join(', ')}
                </p>
            </div>
        );
    }
}

export default ProjectHistoryEntry



// WEBPACK FOOTER //
// src/ProjectHistory/ProjectHistoryEntry.js